import React, { useState } from "react";

import { SpaceTypes } from "../../Constants/Interfaces";
import AboutAccordian from "./AboutAccordian";

interface PolicyTabType {
  item: SpaceTypes;
}

const PolicyTab: React.FC<PolicyTabType> = ({ item }) => {
  return (
    <div className="about-tab-wrapper">
      <div className="about-content">
        <h2>Cancellation Policy</h2>
      </div>

      <AboutAccordian type="policy" details={item.details} />
    </div>
  );
};

export default PolicyTab;
